import React from 'react';
import './App.css';
import './css/foundation.css';
import FormCalc from './FormCalc';
import useDocumentTitle from './useDocumentTitle';
import logo from './logo@2x.png';
import video from './money-background.mp4';

const App = () => {

	useDocumentTitle("Scholarship Calculator | Maryville University");

	return (
		
		<div className="App">
    		<div className="mainContent">
    		<div className="grid-container fluid">
    		<div className="grid-x grid-margin-x" style={{minHeight: '350px'}}>
    			<div className="cell small-6">
		    		<header>
			      		<div><img className="logo" src={logo} alt="Logo" /></div>
			      		<h1>SEIZE YO<span className="red-letter">U</span>R SCHOLARSHIP</h1>
			      		<p className="red-letter">Find the funds to fuel your future.</p>
			      	</header>
		      	</div>
		      	<div className="cell small-6">
		      		<div className="video-container">
			      		<video id="background-video" loop="true" autoplay="" muted>
			      			<source src={video} type="video/mp4" />
			      		</video>
		      		</div>
		      	</div>
		    </div>
		    </div>
    		</div>
    		<section className="calculator">
	    		<div id="formContent" className="form-content">
		    		<div className="form-container">
		    			<FormCalc />
		    		</div>
		    	</div>
		    </section>
    	</div>
		
		);
}

export default App;